import React from "react";
import PropTypes from "prop-types";
import InputAdornment from "@mui/material/InputAdornment";
import TextFieldInput from "@mui/material/TextField";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles(() => ({
    input: {
        "& .MuiFormHelperText-root": {
            fontSize: 14,
            fontFamily: `"Roboto", "Helvetica", "Arial", sans-serif`,
            fontWeight: 300,
            lineHeight: "1.5em",
            color: "#f44336"
        }
    }
}));

function TextField({ errorMessage, type, maxValue, maxValueHelperText, minValue, minValueHelperText, label, ...props }) {
    const classes = useStyles();
    let error = false;
    let helperText = "";
    const adornmentType = type.toLowerCase() === "percentage" ? "end" : "start";
    const value = parseFloat(props.value);
    if ((minValue || minValue == 0) && value < minValue) {
        error = true;
        helperText = minValueHelperText || null;
    }
    if (maxValue && value > maxValue) {
        error = true;
        helperText = maxValueHelperText || null;
    }

    const fieldProps = {};
    if (label) {
        fieldProps.label = label;
    }

    return (
        <TextFieldInput
            className={classes.input}
            style={{ width: "100%", top: 30 }}
            {...fieldProps}
            error={error}
            helperText={errorMessage || helperText}
            InputProps={{
                [adornmentType + "Adornment"]: <InputAdornment position={adornmentType}>{type.toLowerCase() === "percentage" ? "%" : "$"}</InputAdornment>,
            }}
            inputProps={{
                ...props,
            }}
        />
    );
}

TextField.propTypes = {
    label: PropTypes.string,
    minValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    minValueHelperText: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

TextField.defaultProps = {
    label: null,
    minValue: null,
    minValueHelperText: null,
};

export default TextField;
